/* @flow */
import { ReduceStore } from 'flux/utils';

import { ActionTypes } from 'constants/AvatarConstants';
import { dispatcher } from 'lib/Dispatcher';
import GroupAvatars from 'collections/GroupAvatars';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class AvatarStore extends ReduceStore {
  getInitialState() {
    return {
      groupAvatars: {
        loaded: false,
        collection: new GroupAvatars(),
      },
    };
  }

  getGroupAvatars(): GroupAvatars {
    return this.getState().groupAvatars.collection;
  }

  areGroupAvatarsLoaded(): boolean {
    return this.getState().groupAvatars.loaded;
  }

  reduce(state, action) {
    switch (action.type) {
      case ActionTypes.GROUP_AVATARS_LOADED:
        return {
          groupAvatars: {
            loaded: true,
            collection: action.avatars,
          },
        };
      default:
        return state;
    }
  }
}

export default new AvatarStore(dispatcher);
